export enum UserViewLandingPage {
    buyer = 0,
    supplier = 1,
}
